import _pt from "prop-types";
import * as React from 'react';
import { PkpassFieldsType } from '../../../../../../types';
import { usePkpass } from '../../../usePkpass';
import { isObject } from 'lodash';
import { createUseStyles } from 'react-jss';
export const useStyles = createUseStyles({
  root: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  field: {
    color: ({
      labelColor
    }) => labelColor,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    fontSize: ({
      theme
    }) => 11 * theme.scale
  },
  backfield: {
    color: '#7d7d7d',
    fontSize: ({
      theme
    }) => theme.scale * 12,
    marginBottom: ({
      theme
    }) => theme.scale * 4
  }
});
export const getLabelValue = (values, language) => {
  const label = values.label;

  if (isObject(label)) {
    return label[language];
  }

  return label;
};
export const FieldPreviewLabel = props => {
  const {
    language
  } = usePkpass();
  const {
    fieldsType,
    field,
    theme,
    labelColor
  } = props;
  const classes = useStyles({
    theme,
    labelColor
  });
  return /*#__PURE__*/React.createElement("div", {
    className: fieldsType === PkpassFieldsType.BackFields ? undefined : classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: fieldsType === PkpassFieldsType.BackFields ? classes.backfield : classes.field
  }, getLabelValue(field, language) || /*#__PURE__*/React.createElement("span", null, "\xA0")));
};
FieldPreviewLabel.propTypes = {
  labelColor: _pt.string.isRequired
};
//# sourceMappingURL=FieldPreviewLabel.js.map